import { withConfig } from '@/router/navigationGuards';
import { RouteRecordRaw } from 'vue-router';

export const AGENTS_ROUTES = {
  // Main routes
  INDEX: '/agents',
  NEW: '/agents/new',

  // Dynamic routes
  EDIT: (id: string) => `/agents/${id}`,

  // Route names
  NAMES: {
    INDEX: 'AgentIndexView',
    NEW: 'CreateAgentView',
    EDIT: 'UpdateAgentView',
  },
} as const;

export const agentsRoute: RouteRecordRaw = {
  name: 'AgentRouterView',
  path: AGENTS_ROUTES.INDEX,
  component: () => import('@/modules/Agents/views/AgentRouterView.vue'),
  beforeEnter: [withConfig],
  meta: {
    titleLocalizationKey: 'SKILLS.agents',
  },
  children: [
    // Main agents overview page
    {
      name: AGENTS_ROUTES.NAMES.INDEX,
      path: '',
      component: () => import('@/modules/Agents/views/AgentIndexView.vue'),
      meta: {
        title: 'Agents',
      },
    },
    // Create new agent page
    {
      name: AGENTS_ROUTES.NAMES.NEW,
      path: 'new',
      component: () => import('@/modules/Agents/views/AgentView.vue'),
      meta: {
        title: 'Create Agent',
      },
    },
    // Edit existing agent page
    {
      name: AGENTS_ROUTES.NAMES.EDIT,
      path: ':id',
      component: () => import('@/modules/Agents/views/AgentView.vue'),
      meta: {
        title: 'Edit Agent',
      },
    },
  ],
};
